<template>
  <div>
    <!-- <training-header></training-header> -->
    <div class="mdgridviewpage-bg">
      <!-- Page Content -->

      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12" style="padding: 0 !important">
            <div id="header">
              <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <a class="nav-brand d-flex minText" href="#">
                  <img
                    src="../assets/img/fplims/logo_mohfw_1.png"
                    class="py-3"
                  />
                </a>

                <div
                  class="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul class="navbar-nav mr-auto">
                    <li class="nav-item active">
                      <a class="nav-link" href="#"></a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid px-5">
        <div
          class="row dashboardchart-container globalconfigcontainer loginForm"
        >
          <div class="col-lg-5 pt-5" style="">
            <h4 class="formTitle">E-Learning Portal For FP-LMIS <br>  Ministry of Health & Family Welfare <br>Government of India</h4>
            <div class="card m-b-20px m-t-10px">
              <ValidationObserver v-slot="{ handleSubmit }">
                <div class="collapse show" aria-labelledby="headingOne">
                  <div class="card-body c-body px-0">
                    <form
                      @submit.prevent="handleSubmit(onSubmit)"
                      class="d-flex"
                    >
                      <div class="row col-lg-12" style="">
                        <div class="mainform-holder w-100">
                          <div class="col-lg-12">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label text-right"
                                >Name</label
                              >
                              <div class="col-sm-5">
                                <ValidationProvider
                                  name="Firstname"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model.trim="frmAccount['firstname']"
                                    type="text"
                                    class="form-control bg-grey"
                                    placeholder="First"
                                  />
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                              <div class="col-sm-4">
                                <ValidationProvider
                                  name="Last Name"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model.trim="frmAccount['lastname']"
                                    type="text"
                                    class="form-control bg-grey"
                                    placeholder="Last"
                                  />
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-lg-12">
                            <div class="form-group row">
                              <label
                                class="col-sm-4 col-form-label"
                                >Last Name</label>
                              <div class="col-sm-8">
                                <ValidationProvider name="Last Name" rules="required" v-slot="{ errors }">
                                  <input
                                    v-model.trim="frmAccount['lastname']"
                                    type="text"
                                    class="form-control bg-grey"
                                    placeholder=""
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div> -->

                          <div class="col-lg-12">
                            <div class="form-group row">
                              <!-- <div class="col-sm-4"></div> -->
                              <label class="col-sm-3 col-form-label text-right"
                                >Nationality</label
                              >
                              <div class="col-sm-5">
                                <div class="select-wrapper">
                                  <select
                                    class="form-control"
                                    id="country"
                                    name="country"
                                    v-model="nationality"
                                    @change="getNation"
                                    :disabled="ndisabled == 0"
                                  >
                                    <option value="">Select Nationality</option>
                                    <option
                                      v-for="c in countries"
                                      :key="c.Code + '-' + c.Name"
                                      :value="c.Code + '-' + c.Name"
                                    >
                                      {{ c.Name }}
                                    </option>
                                  </select>
                                  <span
                                    v-if="isActive"
                                    v-bind:class="{
                                      active: isActive,
                                      'text-danger': hasError,
                                    }"
                                    class="text-danger"
                                    >This field is required</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group row">
                              <!-- <div class="col-sm-4"></div> -->
                              <label class="col-sm-3 col-form-label text-right"
                                >User Role</label
                              >
                              <div class="col-sm-9">
                                <div class="select-wrapper">
                                  <select
                                    class="form-control"
                                    v-model="userRole"
                                    @change="verifiUserRole"
                                  >
                                    <option value="">Select UserRole</option>
                                    <option v-for="userRoles in selectUserRole">
                                      {{ userRoles.displayName }}
                                    </option>
                                  </select>
                                  <span
                                    v-if="userroleisActive"
                                    v-bind:class="{
                                      active: userroleisActive,
                                      'text-danger': userroleishasError,
                                    }"
                                    class="text-danger"
                                    >This field is required</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12 hide">
                            <div class="form-group row">
                              <!-- <div class="col-sm-4"></div> -->
                              <label class="col-sm-3 col-form-label text-right"
                                >Select Session</label
                              >
                              <div class="col-sm-9">
                                <div class="select-wrapper">
                                  <!-- <multiselect
                                    v-model="selectSes.session"
                                    :options="selectSes"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select Session"
                                    label="session"
                                    track-by="sessionId"
                                    :preselect-first="true"
                                  >
                                  </multiselect> -->
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label text-right"
                                >Mobile</label
                              >
                              <div class="col-sm-9" v-if="odisabled == 0">
                                <ValidationProvider
                                  name="User Name"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model.trim="frmAccount['mobile']"
                                    type="number"
                                    class="form-control bg-grey"
                                    placeholder=""
                                  />
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                              <div class="col-sm-9" v-else>
                                <VuePhoneNumberInput
                                  color="#dc3545"
                                  class=""
                                  v-model="phoneNumber"
                                  :default-country-code="
                                    nationality.split('-')[0]
                                  "
                                  @update="results = JSON.stringify($event)"
                                />
                                <span
                                  v-if="results && !JSON.parse(results).isValid"
                                  class="text-danger"
                                  >Please enter valid number</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group row">
                              <label
                                for="inputContactEmail"
                                class="col-sm-3 col-form-label text-right"
                                >Email</label
                              >
                              <div class="col-sm-9">
                                <ValidationProvider
                                  name="Email"
                                  rules="required|email"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="frmAccount['email']"
                                    type="email"
                                    class="form-control bg-grey"
                                    placeholder=""
                                    autocomplete="new-nemail"
                                  />
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label text-right"
                                >Password</label
                              >
                              <div class="col-sm-5">
                                <ValidationProvider
                                  name="Password"
                                  rules="required|verify_password|min:8|max:16"
                                  v-slot="{ errors }"
                                  vid="confirmation"
                                >
                                  <div class="input-group">
                                    <input
                                      v-model="frmAccount['password']"
                                      type="password"
                                      class="form-control bg-grey"
                                      placeholder="Password"
                                      id="password"
                                      autocomplete="new-paaaassword"
                                    />
                                    <div class="input-group-append">
                                      <span
                                        @click="showPass"
                                        class="input-group-text fa fa-eye bg-grey"
                                      ></span>
                                    </div>
                                  </div>
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                              <div class="col-sm-4">
                                <ValidationProvider
                                  name="Confirm Password"
                                  rules="required|confirmed:confirmation"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="frmAccount['confirm_pass']"
                                    type="password"
                                    class="form-control bg-grey"
                                    placeholder="Confirm Password"
                                  />
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-lg-12">
                            <div class="form-group row">
                              <label
                                class="col-sm-4 col-form-label"
                                >Confirm Password</label
                              >
                              <div class="col-sm-8">
                                <ValidationProvider name="Confirm Password" rules="required|confirmed:confirmation" v-slot="{ errors }" >
                                  <input
                                    v-model="frmAccount['confirm_pass']"
                                    type="password"
                                    class="form-control bg-grey"
                                    placeholder=""
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div> -->
                          <div class="col-lg-12 mt-1">
                            <div class="row">
                              <div class="col-sm-6"></div>
                              <div class="col-sm-6">
                                <div class="form-group mb-0">
                                  <div class="text-left" style="">
                                    <button
                                      type="submit"
                                      class="btn red-button mx-0"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12">
                            <div class="row">
                              <div class="col-sm-3"></div>
                              <div class="col-sm-5 mt-2">
                                <div class="form-group mb-0">
                                  <div class="col m-t-10px" style="">
                                    <a
                                      class="text-dark-yellow"
                                      @click="GotoSignin()"
                                      style="
                                        font-size: 14px;
                                        border-bottom: 1px solid #595959;
                                      "
                                      >Login</a
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-4 mt-2">
                                <div class="form-group mb-0">
                                  <div class="col text-right m-t-10px" style="">
                                    <a
                                      class="text-dark-yellow"
                                      @click="goToActivateAccount"
                                      style="
                                        font-size: 14px;
                                        border-bottom: 1px solid #595959;
                                      "
                                      >Activate Account</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
          <div class="col-lg-1"></div>
          <div class="col-lg-6">
            <div>
              <img
                src="../assets/img/fplims/logo_hum_do.png"
                class="d-block m-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import ApiServices from "../service/ApiServices";
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";
import $ from "jquery";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Multiselect from "vue-multiselect";

//Vue.component('vue-phone-number-input', VuePhoneNumberInput);

//password restrictions
extend("verify_password", {
  message: `The {_field_} must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character`,
  validate: (value) => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  },
});
export default {
  props: {},
  components: {
    trainingHeader,
    trainingFooter,
    VuePhoneNumberInput,
    Multiselect,
  },
  data() {
    return {
      frmAccount: {
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        password: "",
        confirm_pass: "",
        nationality: "",
        userRole: "",
        status: "New",
      },
      otherNationality: "",
      nationality: "",
      userRole: "",
      selectUserRole: [],
      selectSes: [],
      selSes: "",
      UserRoleSelect: "",
      settings: settings,
      countries: [
        { Code: "AF", Name: "Afghanistan" },
        { Code: "AX", Name: "\u00c5land Islands" },
        { Code: "AL", Name: "Albania" },
        { Code: "DZ", Name: "Algeria" },
        { Code: "AS", Name: "American Samoa" },
        { Code: "AD", Name: "Andorra" },
        { Code: "AO", Name: "Angola" },
        { Code: "AI", Name: "Anguilla" },
        { Code: "AQ", Name: "Antarctica" },
        { Code: "AG", Name: "Antigua and Barbuda" },
        { Code: "AR", Name: "Argentina" },
        { Code: "AM", Name: "Armenia" },
        { Code: "AW", Name: "Aruba" },
        { Code: "AU", Name: "Australia" },
        { Code: "AT", Name: "Austria" },
        { Code: "AZ", Name: "Azerbaijan" },
        { Code: "BS", Name: "Bahamas" },
        { Code: "BH", Name: "Bahrain" },
        { Code: "BD", Name: "Bangladesh" },
        { Code: "BB", Name: "Barbados" },
        { Code: "BY", Name: "Belarus" },
        { Code: "BE", Name: "Belgium" },
        { Code: "BZ", Name: "Belize" },
        { Code: "BJ", Name: "Benin" },
        { Code: "BM", Name: "Bermuda" },
        { Code: "BT", Name: "Bhutan" },
        { Code: "BO", Name: "Bolivia, Plurinational State of" },
        { Code: "BQ", Name: "Bonaire, Sint Eustatius and Saba" },
        { Code: "BA", Name: "Bosnia and Herzegovina" },
        { Code: "BW", Name: "Botswana" },
        { Code: "BV", Name: "Bouvet Island" },
        { Code: "BR", Name: "Brazil" },
        { Code: "IO", Name: "British Indian Ocean Territory" },
        { Code: "BN", Name: "Brunei Darussalam" },
        { Code: "BG", Name: "Bulgaria" },
        { Code: "BF", Name: "Burkina Faso" },
        { Code: "BI", Name: "Burundi" },
        { Code: "KH", Name: "Cambodia" },
        { Code: "CM", Name: "Cameroon" },
        { Code: "CA", Name: "Canada" },
        { Code: "CV", Name: "Cape Verde" },
        { Code: "KY", Name: "Cayman Islands" },
        { Code: "CF", Name: "Central African Republic" },
        { Code: "TD", Name: "Chad" },
        { Code: "CL", Name: "Chile" },
        { Code: "CN", Name: "China" },
        { Code: "CX", Name: "Christmas Island" },
        { Code: "CC", Name: "Cocos (Keeling) Islands" },
        { Code: "CO", Name: "Colombia" },
        { Code: "KM", Name: "Comoros" },
        { Code: "CG", Name: "Congo" },
        { Code: "CD", Name: "Congo, the Democratic Republic of the" },
        { Code: "CK", Name: "Cook Islands" },
        { Code: "CR", Name: "Costa Rica" },
        { Code: "CI", Name: "C\u00f4te d'Ivoire" },
        { Code: "HR", Name: "Croatia" },
        { Code: "CU", Name: "Cuba" },
        { Code: "CW", Name: "Cura\u00e7ao" },
        { Code: "CY", Name: "Cyprus" },
        { Code: "CZ", Name: "Czech Republic" },
        { Code: "DK", Name: "Denmark" },
        { Code: "DJ", Name: "Djibouti" },
        { Code: "DM", Name: "Dominica" },
        { Code: "DO", Name: "Dominican Republic" },
        { Code: "EC", Name: "Ecuador" },
        { Code: "EG", Name: "Egypt" },
        { Code: "SV", Name: "El Salvador" },
        { Code: "GQ", Name: "Equatorial Guinea" },
        { Code: "ER", Name: "Eritrea" },
        { Code: "EE", Name: "Estonia" },
        { Code: "ET", Name: "Ethiopia" },
        { Code: "FK", Name: "Falkland Islands (Malvinas)" },
        { Code: "FO", Name: "Faroe Islands" },
        { Code: "FJ", Name: "Fiji" },
        { Code: "FI", Name: "Finland" },
        { Code: "FR", Name: "France" },
        { Code: "GF", Name: "French Guiana" },
        { Code: "PF", Name: "French Polynesia" },
        { Code: "TF", Name: "French Southern Territories" },
        { Code: "GA", Name: "Gabon" },
        { Code: "GM", Name: "Gambia" },
        { Code: "GE", Name: "Georgia" },
        { Code: "DE", Name: "Germany" },
        { Code: "GH", Name: "Ghana" },
        { Code: "GI", Name: "Gibraltar" },
        { Code: "GR", Name: "Greece" },
        { Code: "GL", Name: "Greenland" },
        { Code: "GD", Name: "Grenada" },
        { Code: "GP", Name: "Guadeloupe" },
        { Code: "GU", Name: "Guam" },
        { Code: "GT", Name: "Guatemala" },
        { Code: "GG", Name: "Guernsey" },
        { Code: "GN", Name: "Guinea" },
        { Code: "GW", Name: "Guinea-Bissau" },
        { Code: "GY", Name: "Guyana" },
        { Code: "HT", Name: "Haiti" },
        { Code: "HM", Name: "Heard Island and McDonald Islands" },
        { Code: "VA", Name: "Holy See (Vatican City State)" },
        { Code: "HN", Name: "Honduras" },
        { Code: "HK", Name: "Hong Kong" },
        { Code: "HU", Name: "Hungary" },
        { Code: "IS", Name: "Iceland" },
        { Code: "IN", Name: "India" },
        { Code: "ID", Name: "Indonesia" },
        { Code: "IR", Name: "Iran, Islamic Republic of" },
        { Code: "IQ", Name: "Iraq" },
        { Code: "IE", Name: "Ireland" },
        { Code: "IM", Name: "Isle of Man" },
        { Code: "IL", Name: "Israel" },
        { Code: "IT", Name: "Italy" },
        { Code: "JM", Name: "Jamaica" },
        { Code: "JP", Name: "Japan" },
        { Code: "JE", Name: "Jersey" },
        { Code: "JO", Name: "Jordan" },
        { Code: "KZ", Name: "Kazakhstan" },
        { Code: "KE", Name: "Kenya" },
        { Code: "KI", Name: "Kiribati" },
        { Code: "KP", Name: "Korea, Democratic People's Republic of" },
        { Code: "KR", Name: "Korea, Republic of" },
        { Code: "KW", Name: "Kuwait" },
        { Code: "KG", Name: "Kyrgyzstan" },
        { Code: "LA", Name: "Lao People's Democratic Republic" },
        { Code: "LV", Name: "Latvia" },
        { Code: "LB", Name: "Lebanon" },
        { Code: "LS", Name: "Lesotho" },
        { Code: "LR", Name: "Liberia" },
        { Code: "LY", Name: "Libya" },
        { Code: "LI", Name: "Liechtenstein" },
        { Code: "LT", Name: "Lithuania" },
        { Code: "LU", Name: "Luxembourg" },
        { Code: "MO", Name: "Macao" },
        { Code: "MK", Name: "Macedonia, the Former Yugoslav Republic of" },
        { Code: "MG", Name: "Madagascar" },
        { Code: "MW", Name: "Malawi" },
        { Code: "MY", Name: "Malaysia" },
        { Code: "MV", Name: "Maldives" },
        { Code: "ML", Name: "Mali" },
        { Code: "MT", Name: "Malta" },
        { Code: "MH", Name: "Marshall Islands" },
        { Code: "MQ", Name: "Martinique" },
        { Code: "MR", Name: "Mauritania" },
        { Code: "MU", Name: "Mauritius" },
        { Code: "YT", Name: "Mayotte" },
        { Code: "MX", Name: "Mexico" },
        { Code: "FM", Name: "Micronesia, Federated States of" },
        { Code: "MD", Name: "Moldova, Republic of" },
        { Code: "MC", Name: "Monaco" },
        { Code: "MN", Name: "Mongolia" },
        { Code: "ME", Name: "Montenegro" },
        { Code: "MS", Name: "Montserrat" },
        { Code: "MA", Name: "Morocco" },
        { Code: "MZ", Name: "Mozambique" },
        { Code: "MM", Name: "Myanmar" },
        { Code: "NA", Name: "Namibia" },
        { Code: "NR", Name: "Nauru" },
        { Code: "NP", Name: "Nepal" },
        { Code: "NL", Name: "Netherlands" },
        { Code: "NC", Name: "New Caledonia" },
        { Code: "NZ", Name: "New Zealand" },
        { Code: "NI", Name: "Nicaragua" },
        { Code: "NE", Name: "Niger" },
        { Code: "NG", Name: "Nigeria" },
        { Code: "NU", Name: "Niue" },
        { Code: "NF", Name: "Norfolk Island" },
        { Code: "MP", Name: "Northern Mariana Islands" },
        { Code: "NO", Name: "Norway" },
        { Code: "OM", Name: "Oman" },
        { Code: "PK", Name: "Pakistan" },
        { Code: "PW", Name: "Palau" },
        { Code: "PS", Name: "Palestine, State of" },
        { Code: "PA", Name: "Panama" },
        { Code: "PG", Name: "Papua New Guinea" },
        { Code: "PY", Name: "Paraguay" },
        { Code: "PE", Name: "Peru" },
        { Code: "PH", Name: "Philippines" },
        { Code: "PN", Name: "Pitcairn" },
        { Code: "PL", Name: "Poland" },
        { Code: "PT", Name: "Portugal" },
        { Code: "PR", Name: "Puerto Rico" },
        { Code: "QA", Name: "Qatar" },
        { Code: "RE", Name: "R\u00e9union" },
        { Code: "RO", Name: "Romania" },
        { Code: "RU", Name: "Russian Federation" },
        { Code: "RW", Name: "Rwanda" },
        { Code: "BL", Name: "Saint Barth\u00e9lemy" },
        { Code: "SH", Name: "Saint Helena, Ascension and Tristan da Cunha" },
        { Code: "KN", Name: "Saint Kitts and Nevis" },
        { Code: "LC", Name: "Saint Lucia" },
        { Code: "MF", Name: "Saint Martin (French part)" },
        { Code: "PM", Name: "Saint Pierre and Miquelon" },
        { Code: "VC", Name: "Saint Vincent and the Grenadines" },
        { Code: "WS", Name: "Samoa" },
        { Code: "SM", Name: "San Marino" },
        { Code: "ST", Name: "Sao Tome and Principe" },
        { Code: "SA", Name: "Saudi Arabia" },
        { Code: "SN", Name: "Senegal" },
        { Code: "RS", Name: "Serbia" },
        { Code: "SC", Name: "Seychelles" },
        { Code: "SL", Name: "Sierra Leone" },
        { Code: "SG", Name: "Singapore" },
        { Code: "SX", Name: "Sint Maarten (Dutch part)" },
        { Code: "SK", Name: "Slovakia" },
        { Code: "SI", Name: "Slovenia" },
        { Code: "SB", Name: "Solomon Islands" },
        { Code: "SO", Name: "Somalia" },
        { Code: "ZA", Name: "South Africa" },
        { Code: "GS", Name: "South Georgia and the South Sandwich Islands" },
        { Code: "SS", Name: "South Sudan" },
        { Code: "ES", Name: "Spain" },
        { Code: "LK", Name: "Sri Lanka" },
        { Code: "SD", Name: "Sudan" },
        { Code: "SR", Name: "Suriname" },
        { Code: "SJ", Name: "Svalbard and Jan Mayen" },
        { Code: "SZ", Name: "Swaziland" },
        { Code: "SE", Name: "Sweden" },
        { Code: "CH", Name: "Switzerland" },
        { Code: "SY", Name: "Syrian Arab Republic" },
        { Code: "TW", Name: "Taiwan, Province of China" },
        { Code: "TJ", Name: "Tajikistan" },
        { Code: "TZ", Name: "Tanzania, United Republic of" },
        { Code: "TH", Name: "Thailand" },
        { Code: "TL", Name: "Timor-Leste" },
        { Code: "TG", Name: "Togo" },
        { Code: "TK", Name: "Tokelau" },
        { Code: "TO", Name: "Tonga" },
        { Code: "TT", Name: "Trinidad and Tobago" },
        { Code: "TN", Name: "Tunisia" },
        { Code: "TR", Name: "Turkey" },
        { Code: "TM", Name: "Turkmenistan" },
        { Code: "TC", Name: "Turks and Caicos Islands" },
        { Code: "TV", Name: "Tuvalu" },
        { Code: "UG", Name: "Uganda" },
        { Code: "UA", Name: "Ukraine" },
        { Code: "AE", Name: "United Arab Emirates" },
        { Code: "GB", Name: "United Kingdom" },
        { Code: "US", Name: "United States" },
        { Code: "UM", Name: "United States Minor Outlying Islands" },
        { Code: "UY", Name: "Uruguay" },
        { Code: "UZ", Name: "Uzbekistan" },
        { Code: "VU", Name: "Vanuatu" },
        { Code: "VE", Name: "Venezuela, Bolivarian Republic of" },
        { Code: "VN", Name: "Viet Nam" },
        { Code: "VG", Name: "Virgin Islands, British" },
        { Code: "VI", Name: "Virgin Islands, U.S." },
        { Code: "WF", Name: "Wallis and Futuna" },
        { Code: "EH", Name: "Western Sahara" },
        { Code: "YE", Name: "Yemen" },
        { Code: "ZM", Name: "Zambia" },
        { Code: "ZW", Name: "Zimbabwe" },
      ],
      odisabled: 0,
      ndisabled: 1,
      isActive: false,
      hasError: false,
      results: null,
      userroleisActive: false,
      userroleishasError: false,
      sesisActive: false,
      sesishasError: false,
      phoneNumber: "",
    };
  },
  methods: {
    getNation() {
      if (this.nationality == "") {
        this.isActive = true;
        this.hasError = true;
        this.odisabled = 0;
      } else {
        this.odisabled = 1;
        this.isActive = false;
        this.hasError = false;
      }
    },
    getOther() {
      if (this.otherNationality == "") {
        this.ndisabled = 1;
        this.isActive = true;
        this.hasError = true;
      } else {
        this.ndisabled = 0;
        this.isActive = false;
        this.hasError = false;
      }
    },
    verifiUserRole() {
      if (this.userRole == "") {
        this.userroleisActive = true;
        this.userroleishasError = true;
      } else {
        this.userroleisActive = false;
        this.userroleishasError = false;
      }
    },
    verifiSelSes() {
      if (this.userRole == "") {
        this.sesisActive = true;
        this.sesishasError = true;
      } else {
        this.sesisActive = false;
        this.sesishasError = false;
      }
    },
    getUserRole() {
      ApiServices.RestGetCall("api/userRoles.json")
        .then((Response) => {
          this.selectUserRole = Response.userRoles;
        })
        .catch((error) => {
          this.$root.loading = false;
          this.$swal({
            text: error,
          });
        });
    },
    getTrainSes() {
      ApiServices.RestGetCall("api/avenir/training/getTrainingSessions")
        .then((Response) => {
          console.log(Response);
          this.selectSes = Response.sessions;
        })
        .catch((error) => {
          this.$root.loading = false;
          this.$swal({
            text: error,
          });
        });
    },
    showPass() {
      let passwordField = document.querySelector("#password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    GotoSignin() {
      this.$router.push("/");
    },
    goToActivateAccount() {
      this.$router.push("/activate");
    },
    onSubmit() {
      //this.$root.loading = true;
      if (!this.isActive) {
        if (this.otherNationality != "") {
          this.frmAccount["nationality"] = this.otherNationality;
        } else {
          this.frmAccount["nationality"] = this.nationality;
        }
        if (this.otherNationality == "") {
          this.phoneNumber = JSON.parse(this.results)["formatInternational"];
          this.frmAccount["mobile"] = this.phoneNumber;
        }
        if (this.userRole != "") {
          this.frmAccount["userRole"] = this.userRole;
        }
        console.log(this.frmAccount, this.nationality);
        let headers = { Authorization: "Basic YWRtaW46ZGlzdHJpY3Q=" };
        ApiServices.RestPostCall("api/avenir/register/request", this.frmAccount)
          .then((Response) => {
            console.log(Response);
            this.$root.loading = false;
            if (Response.status && Response.status.toLowerCase() == "success") {
              this.$swal({
                text: Response.message,
              }).then(() => {
                this.$router.push("/activate");
              });
            } else {
              this.$swal({
                text: Response.message,
              });
            }
          })
          .catch((error) => {
            this.$root.loading = false;
            this.$swal({
              text: error,
            });
          });
      }
    },
  },
  mounted() {
    this.getUserRole();
    this.getTrainSes();
  },
  updated() {},
};
</script>

<style scoped lang="scss">
.mdgridviewpage-bg {
  background-color: #ededed;
  background: url("../assets/img/fplims/login_bg.jpg") no-repeat;
  background-size: cover;
  background-position: top;
  min-height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
}

body.green-theme .mdgridviewpage-bg {
  background-color: #006600;
  background: url("../assets/img/green-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 20px 40px;
}
.mainform-holder {
  /*background: #fff;
  -webkit-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  border-radius: 10px;*/
  padding: 8px 5px;
}

.c-body {
  background-color: transparent;
}

.card {
  background-color: transparent;
  box-shadow: 0px 0px 0px 0px 4px rgb(186, 186, 186) !important;
  border-radius: 10px;
  border: 0px !important;
}
.form-control {
  background: #fff !important;
  color: #595959 !important;
  font-size: 14px !important;
  font-weight: 200;
  border: 1px solid #595959;
  border-radius: 6px !important;
}
a {
  cursor: pointer;
  color: rgb(121, 121, 121);
}
a:hover {
  text-decoration: none !important;
}
input:-internal-autofill-selected {
  background: #ddd !important;
  border-color: #f2f2f2 !important;
}
* {
  color: #4c4c4c;
}
label {
  font-weight: 200;
}
.card-header {
  border-bottom: 0px;
  border-radius: 10px 10px 0 0 !important;
  padding: 8px 12px !important;
}
.input-group {
  position: relative;
  margin-bottom: 0px;
}
.input-group-append {
  position: absolute;
  right: 4px;
  top: 4px;
  .input-group-text {
    background-color: transparent !important;
    border: transparent;
    z-index: 999;
    cursor: pointer;
    color: #7d7d7d;
    padding: 0.175rem 0.75rem;
  }
}
#inputContactEmailPassword {
  padding-right: 36px;
}
.globalconfigcontainer {
  display: flex;
  justify-content: center;
  // align-items: center;
  // height: 80vh;
}
.navbar {
  background: transparent !important;
}
.logoImage {
  display: flex;
  justify-content: center;
  position: absolute;
}
.logoImageDiv {
  position: relative;
  z-index: 9;
  top: -90px;
  padding: 10px 10px;
  left: 0;
  width: 175px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.78);
  border-top-left-radius: 110px;
  border-top-right-radius: 110px;
  /* border: 10px solid gray; */
  border-bottom: 0;
}
.logoImageDiv img {
  position: absolute;
  top: 26px;
  left: 36px;
}
.headerTitle {
  font-size: 2rem;
  height: 100%;
  display: flex;
  justify-content: center;
  // align-items: center;
}
.minText p {
  margin-bottom: 0;
  padding-top: 3%;
  font-size: 16px;
  margin-left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.minText p span {
  display: block;
  color: #000;
  font-size: 14px;
  font-weight: 500;
}
// #footer .c_div .c_logo{
//   width: 15%;
// }
footer {
  background-color: #f6f0f8;
}
.nav-brand:hover {
  text-decoration: none !important;
}
.loginForm {
  .formTitle {
    font-family: Montserrat-Black;
    font-size: 1.375rem;
    color: #42413c;
  }
  label {
    color: #42413c;
    font-weight: 400;
  }
}
select {
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  -moz-appearance: none !important;
}
.select-wrapper {
  position: relative;
}

.select-wrapper:after {
  font-family: FontAwesome;
  content: "\f0d7";
  font-size: 16px;
  position: absolute;
  top: 8px;
  right: 14px;
  color: #676767;
  pointer-events: none;
}
</style>



